'use strict';
(function() {
  angular.module('fetchtv.Directives')
    .directive('ftCreditCardForm', function() {
      return {
        replace: true,
        restrict: 'E',
        scope: {
          'cardHolderName': '=',
          'cardNumber': '=',
          'expiryDate': '=',
          'acceptedCardTypes': '=',
          'editing': '=',
          'hint': '=',
          'cardOk': '=',
          'card': '='
        },
        templateUrl: 'views/common/creditcardform.html',
        controller: [
          '$scope',
          'payment',
          function(
            $scope,
            payment,
          ) {
            function updateHint(cardNumber) {
              if (angular.isDefined(cardNumber)) {
                $scope.hint = 'XXXX XXXX XXXX ' + cardNumber.substring(cardNumber.length - 4);
              }
            }

            function cardDetailsChanged() {
              $scope.card = payment.cardFromNumber($scope.cardNumber);

              // Card is validated with both the ftBinCheck and ftCardValidation directives
              $scope.cardOk = $scope.form.$valid;
            }

            $scope.cardNumberError = function() {
              if (!$scope.form.card_number.$dirty) {
                return;
              }
              var errors = $scope.form.card_number.$error;
              if (errors.cardTypeValid || errors.ft_bin_check) {
                return "An Australian Visa or Mastercard number is required";
              }

              if (errors.cardNumber && !errors.cardNumberLength) {
                return "Invalid card number";
              }
            };

            $scope.getCardPlaceholderText = function() {
              if ($scope.editing) {
                return 'Card Number';
              }
              return $scope.hint;
            };

            $scope.$watch('editing', function(newVal) {
              if (newVal) {
                $scope.cardNumber = undefined;
                $scope.hint = undefined;
                $scope.cardHolderName = undefined;
                $scope.expiryDate = undefined;
              }
            });

            $scope.$watch('cardNumber', function(cardNumber) {
              if (cardNumber && cardNumber.length >= 4) {
                updateHint(cardNumber);
              }
            });

            $scope.$watch('form.$valid', cardDetailsChanged);
          }
        ]
      };
    });
})();

